module.exports = __webpack_public_path__ + "img/svg/background-no-money.4328da726d170f07d1c003af84253bc0.svg";